// extracted by mini-css-extract-plugin
module.exports = {"base":"FilterResetButton-module-base","icon":"FilterResetButton-module-icon","title":"FilterResetButton-module-title"};